interface ICriteria {
    class?: string;
    levels?: string;
}

export const formatDateValue = (nextAnnDate: string): string => {
    const nextAnniversaryDate = new Date(nextAnnDate);
    const yearValue = nextAnniversaryDate?.getFullYear().toString().replace('-', '').slice(2);
    const monthValue = nextAnniversaryDate?.getMonth();
    const updatedMonthValue = monthValue + 1;
    const dateValue = nextAnniversaryDate?.getDate();
    const finalDateValue = dateValue.toString().length === 1 ? `0${dateValue}` : dateValue;
    const finalMonthValue =
        updatedMonthValue.toString().length === 1 ? `0${updatedMonthValue}` : updatedMonthValue;
    const updatedDate = `${yearValue}${finalMonthValue}${finalDateValue}`;

    return updatedDate;
};

export const truncateContent = (str: string, strlength: number) => {
    return str?.length > strlength ? `${str.substring(0, strlength - 1)}...` : str;
};

export const formatPoints = (points: number | null) => {
    if (points || points === 0) {
        return points >= 0 ? `+${points}` : `-${Math.abs(points)}`;
    }

    return 0;
};

export const formatLoyaltyLevel = (loyaltyLevel: string) => {
    const parsedLoyaltyLevels = JSON.parse(loyaltyLevel);
    const formattedLevel = parsedLoyaltyLevels
        .filter((levelDetails: ICriteria) => levelDetails?.class === 'LoyaltyMember')
        .map((levelDetails: ICriteria) => ({ loyaltyLevels: levelDetails?.levels }));

    return formattedLevel[0] ? formattedLevel[0]?.loyaltyLevels : '';
};

export const scrollToSection = (hashVal: string, UniqueID: string) => {
    if (hashVal) {
        const hash = hashVal.replace('#', '');

        if (hash === UniqueID) {
            const element = document.getElementById(hash);
            setTimeout(function () {
                element?.scrollIntoView();
            }, 3000);

            return true;
        }
    }
};
